export const NAMESPACE = 'insurance';
